import { render, staticRenderFns } from "./LifeEstimateConsultation.vue?vue&type=template&id=6a4a7b20&"
import script from "./LifeEstimateConsultation.vue?vue&type=script&lang=js&"
export * from "./LifeEstimateConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports